webpackJsonp([29],{

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var boxBase = this.el.querySelector("#box-base");
      var boxDetails = this.el.querySelector("#box-details");
      var boxBuilding = this.el.querySelector("#box-building");
      var boxCardOne = this.el.querySelector("#box-card-one");
      var boxCardTwo = this.el.querySelector("#box-card-two");

      this.animation = new TimelineMax({ repeat: -1, repeatDelay: 1 }).to(boxCardOne, 1, { x: 25, y: 410, rotation: 10 }).to(boxCardTwo, 1, { x: -25, y: 410, rotation: -10 }).to([boxDetails, boxCardOne, boxCardTwo], 0.1, { opacity: 0 }).to(boxBase, 1, { morphSVG: { shape: boxBuilding, shapeIndex: 5 } }).to(boxBase, 1, { morphSVG: { shape: boxBase, shapeIndex: 5 }, delay: 1 }).to([boxDetails, boxCardOne, boxCardTwo], 0.2, { opacity: 1 });

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "0 0 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "clipPath",
          { id: "government-clip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { clipPath: "url(#government-clip)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300",
            fill: "#AB47BC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "box-building",
            d: "M220.75 407.78h-44.08l4.67-148.92h34.73l4.68 148.92zm158.29 0h44.08l-4.67-148.92h-34.73l-4.68 148.92zM299.9 144.92l-151.93 69.86v13.36h303.87v-13.36L299.9 144.92zm-19.76 113.94h-34.73l-4.67 148.92h44.08l-4.68-148.92zm34.84 148.92h44.08l-4.67-148.92h-34.73l-4.68 148.92zm140.19 43.41v-18.7H438.7l-.23-18.7H161.32l-.22 18.7h-16.47v18.7h-15.36v18.63h341.26v-18.63h-15.36z",
            opacity: "0",
            fill: "none"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "box-card-one" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#F5F5F5", d: "M212.21-170H327.8v158.17H212.21z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#F5F5F5",
              stroke: "#212121",
              strokeWidth: "2",
              strokeMiterlimit: "10",
              d: "M296.16-123.46h13.08v13.08h-13.08zM296.16-104.3h13.08v13.08h-13.08zM296.16-85.29h13.08v13.08h-13.08z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#424242",
              d: "M227.72-119.74h62.05v5.33h-62.05zM227.72-100.42h62.05v5.33h-62.05zM227.72-81.41h62.05v5.33h-62.05z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "none",
              stroke: "#00838F",
              strokeWidth: "3",
              strokeMiterlimit: "10",
              d: "M289.77-108.86l23.42 17.95M289.77-86.86l23.42-22"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "box-card-two" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#F5F5F5", d: "M272.21-170H387.8v158.17H272.21z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#F5F5F5",
              stroke: "#212121",
              strokeWidth: "2",
              strokeMiterlimit: "10",
              d: "M356.16-123.46h13.08v13.08h-13.08zM356.16-104.3h13.08v13.08h-13.08zM356.16-85.29h13.08v13.08h-13.08z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#424242",
              d: "M287.72-119.74h62.05v5.33h-62.05zM287.72-100.42h62.05v5.33h-62.05zM287.72-81.41h62.05v5.33h-62.05z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "none",
              stroke: "#00838F",
              strokeWidth: "3",
              strokeMiterlimit: "10",
              d: "M349.77-108.86l23.42 17.95M349.77-86.86l23.42-22"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "box-base",
            fill: "#F5F5F5",
            d: "M162.91 216.87h273.96v252.95H162.91z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "box-details" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M280.81 273.1v-37.67h38.37v37.67c0 10.6-8.59 19.19-19.19 19.19-10.59 0-19.18-8.59-19.18-19.19z",
              fill: "#757575"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              opacity: ".16",
              fill: "#212121",
              d: "M162.91 228.14h273.96v25.53H162.91z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#FFF", d: "M443.9 242.14H156.1V171h287.8z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
              cx: "300",
              cy: "277",
              rx: "19.19",
              ry: "18.25",
              fill: "none",
              stroke: "#373737",
              strokeWidth: "7",
              strokeMiterlimit: "10"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M289.9 275h20.19c8.53 0 14.8 8.01 12.76 16.29l-1.93 7.83c-2.38 9.62-11.01 16.38-20.92 16.38-9.91 0-18.54-6.76-20.92-16.38l-1.93-7.83c-2.05-8.28 4.22-16.29 12.75-16.29z",
              fill: "#BDBDBD"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M299.25 246h1.5c2.62 0 4.75 2.13 4.75 4.75v16c0 2.62-2.13 4.75-4.75 4.75h-1.5c-2.62 0-4.75-2.13-4.75-4.75v-16c0-2.62 2.13-4.75 4.75-4.75z",
              fill: "#616161"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M305.75 288.5c0-3.73-2.57-6.75-5.75-6.75s-5.75 3.02-5.75 6.75c0 2.14.85 4.04 2.17 5.28l-2.17 14.13h11.35l-2.16-14.02c1.4-1.23 2.31-3.18 2.31-5.39z",
              fill: "#212121"
            })
          )
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 29.97790f08ba0d30a15cb5.js